/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * APIFlask
 * OpenAPI spec version: 0.1.0
 */
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useMutation, useQuery } from '@tanstack/react-query';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import axios from 'axios';

import type {
  DeleteReportsReportIdFiltersParams,
  DynamicWorkspaceResponse,
  HTTPError,
  LoginRequest,
  ReportFilter,
  SaveReportFilterIn,
  UpdateReportFilterInUpdate,
  ValidationError,
} from './types';

/**
 * @summary Health Check
 */
export const getHealth = (options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
  return axios.get(`${window._env_.POWER_BI_LIST_URL}/health`, options);
};

export const getGetHealthQueryKey = () => {
  return [`${window._env_.POWER_BI_LIST_URL}/health`] as const;
};

export const getGetHealthQueryOptions = <
  TData = Awaited<ReturnType<typeof getHealth>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetHealthQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getHealth>>> = ({ signal }) =>
    getHealth({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getHealth>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetHealthQueryResult = NonNullable<Awaited<ReturnType<typeof getHealth>>>;
export type GetHealthQueryError = AxiosError<unknown>;

/**
 * @summary Health Check
 */
export const useGetHealth = <TData = Awaited<ReturnType<typeof getHealth>>, TError = AxiosError<unknown>>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getHealth>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetHealthQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Auth
 */
export const postAdminAuth = (
  loginRequest: LoginRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  const formUrlEncoded = new URLSearchParams();
  formUrlEncoded.append('email', loginRequest.email);
  formUrlEncoded.append('password', loginRequest.password);

  return axios.post(`${window._env_.POWER_BI_LIST_URL}/admin/auth`, formUrlEncoded, options);
};

export const getPostAdminAuthMutationOptions = <TError = AxiosError<ValidationError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postAdminAuth>>, TError, { data: LoginRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<Awaited<ReturnType<typeof postAdminAuth>>, TError, { data: LoginRequest }, TContext> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAdminAuth>>, { data: LoginRequest }> = (props) => {
    const { data } = props ?? {};

    return postAdminAuth(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAdminAuthMutationResult = NonNullable<Awaited<ReturnType<typeof postAdminAuth>>>;
export type PostAdminAuthMutationBody = LoginRequest;
export type PostAdminAuthMutationError = AxiosError<ValidationError>;

/**
 * @summary Auth
 */
export const usePostAdminAuth = <TError = AxiosError<ValidationError>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof postAdminAuth>>, TError, { data: LoginRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<Awaited<ReturnType<typeof postAdminAuth>>, TError, { data: LoginRequest }, TContext> => {
  const mutationOptions = getPostAdminAuthMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * @summary Login
 */
export const getAdminLogin = (options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
  return axios.get(`${window._env_.POWER_BI_LIST_URL}/admin/login`, options);
};

export const getGetAdminLoginQueryKey = () => {
  return [`${window._env_.POWER_BI_LIST_URL}/admin/login`] as const;
};

export const getGetAdminLoginQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLogin>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLogin>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminLoginQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLogin>>> = ({ signal }) =>
    getAdminLogin({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLogin>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminLoginQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLogin>>>;
export type GetAdminLoginQueryError = AxiosError<unknown>;

/**
 * @summary Login
 */
export const useGetAdminLogin = <
  TData = Awaited<ReturnType<typeof getAdminLogin>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLogin>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAdminLoginQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * @summary Logout
 */
export const getAdminLogout = (options?: AxiosRequestConfig): Promise<AxiosResponse<unknown>> => {
  return axios.get(`${window._env_.POWER_BI_LIST_URL}/admin/logout`, options);
};

export const getGetAdminLogoutQueryKey = () => {
  return [`${window._env_.POWER_BI_LIST_URL}/admin/logout`] as const;
};

export const getGetAdminLogoutQueryOptions = <
  TData = Awaited<ReturnType<typeof getAdminLogout>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLogout>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAdminLogoutQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminLogout>>> = ({ signal }) =>
    getAdminLogout({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAdminLogout>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAdminLogoutQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminLogout>>>;
export type GetAdminLogoutQueryError = AxiosError<unknown>;

/**
 * @summary Logout
 */
export const useGetAdminLogout = <
  TData = Awaited<ReturnType<typeof getAdminLogout>>,
  TError = AxiosError<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminLogout>>, TError, TData>>;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetAdminLogoutQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Raises:
HTTPError: If the workspaces cannot be found for the user's addons.
HTTPError: If an unexpected error occurs.
HTTPError: If an HTTPException occurs.

Returns a list of workspaces and their reports.
Example:
{
"workspaces": [
{
"workspaceName": "Workspace 1",
"appPath": "/workspace-1",
"reports": [
{
"id": "report-id-1",
"name": "Report 1",
"datasetId": "dataset-id-1",
"datasetWorkspaceId": "workspace-id-1",
"webUrl": "web-url-1",
}
]
"slices": []
}
],
"accessToken": "token",
"tokenId": "tokenId",
"expiration": "expiration"
}
}
 * @summary Fetches the report list for the user's addons.
 */
export const getWorkspaceNameReports = (
  workspaceName: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<DynamicWorkspaceResponse>> => {
  return axios.get(`${window._env_.POWER_BI_LIST_URL}/${workspaceName}/reports`, options);
};

export const getGetWorkspaceNameReportsQueryKey = (workspaceName: string) => {
  return [`${window._env_.POWER_BI_LIST_URL}/${workspaceName}/reports`] as const;
};

export const getGetWorkspaceNameReportsQueryOptions = <
  TData = Awaited<ReturnType<typeof getWorkspaceNameReports>>,
  TError = AxiosError<HTTPError>,
>(
  workspaceName: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceNameReports>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetWorkspaceNameReportsQueryKey(workspaceName);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getWorkspaceNameReports>>> = ({ signal }) =>
    getWorkspaceNameReports(workspaceName, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!workspaceName, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getWorkspaceNameReports>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetWorkspaceNameReportsQueryResult = NonNullable<Awaited<ReturnType<typeof getWorkspaceNameReports>>>;
export type GetWorkspaceNameReportsQueryError = AxiosError<HTTPError>;

/**
 * @summary Fetches the report list for the user's addons.
 */
export const useGetWorkspaceNameReports = <
  TData = Awaited<ReturnType<typeof getWorkspaceNameReports>>,
  TError = AxiosError<HTTPError>,
>(
  workspaceName: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getWorkspaceNameReports>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetWorkspaceNameReportsQueryOptions(workspaceName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};

/**
 * Raises:
HTTPError: If the filter cannot be saved to database.
HTTPError: If an unexpected error occurs.
HTTPError: If an HTTPException occurs.

Returns a saved filter.
Example:
{
"id": "1",
"reportId": "123123-1231231-123131-1231",
"userId": "1234",
"name": "filter",
"isDefaultFilter": "False",
"settings": [
{
"title": "visual title from Power BI",
"filters": []
}
]
}
 * @summary Saves the report filter
 */
export const postReportsReportIdFilters = (
  reportId: string,
  saveReportFilterIn: SaveReportFilterIn,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReportFilter>> => {
  return axios.post(`${window._env_.POWER_BI_LIST_URL}/reports/${reportId}/filters`, saveReportFilterIn, options);
};

export const getPostReportsReportIdFiltersMutationOptions = <
  TError = AxiosError<HTTPError | ValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postReportsReportIdFilters>>,
    TError,
    { reportId: string; data: SaveReportFilterIn },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postReportsReportIdFilters>>,
  TError,
  { reportId: string; data: SaveReportFilterIn },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postReportsReportIdFilters>>,
    { reportId: string; data: SaveReportFilterIn }
  > = (props) => {
    const { reportId, data } = props ?? {};

    return postReportsReportIdFilters(reportId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostReportsReportIdFiltersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postReportsReportIdFilters>>
>;
export type PostReportsReportIdFiltersMutationBody = SaveReportFilterIn;
export type PostReportsReportIdFiltersMutationError = AxiosError<HTTPError | ValidationError>;

/**
 * @summary Saves the report filter
 */
export const usePostReportsReportIdFilters = <
  TError = AxiosError<HTTPError | ValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postReportsReportIdFilters>>,
    TError,
    { reportId: string; data: SaveReportFilterIn },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof postReportsReportIdFilters>>,
  TError,
  { reportId: string; data: SaveReportFilterIn },
  TContext
> => {
  const mutationOptions = getPostReportsReportIdFiltersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Raises:
HTTPError: If the filter cannot be updated
HTTPError: If an unexpected error occurs.
HTTPError: If an HTTPException occurs.

Returns success or error
 * @summary Deletes multiple filters
 */
export const deleteReportsReportIdFilters = (
  reportId: string,
  params: DeleteReportsReportIdFiltersParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<unknown>> => {
  return axios.delete(`${window._env_.POWER_BI_LIST_URL}/reports/${reportId}/filters`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getDeleteReportsReportIdFiltersMutationOptions = <
  TError = AxiosError<HTTPError | ValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReportsReportIdFilters>>,
    TError,
    { reportId: string; params: DeleteReportsReportIdFiltersParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteReportsReportIdFilters>>,
  TError,
  { reportId: string; params: DeleteReportsReportIdFiltersParams },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteReportsReportIdFilters>>,
    { reportId: string; params: DeleteReportsReportIdFiltersParams }
  > = (props) => {
    const { reportId, params } = props ?? {};

    return deleteReportsReportIdFilters(reportId, params, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteReportsReportIdFiltersMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteReportsReportIdFilters>>
>;

export type DeleteReportsReportIdFiltersMutationError = AxiosError<HTTPError | ValidationError>;

/**
 * @summary Deletes multiple filters
 */
export const useDeleteReportsReportIdFilters = <
  TError = AxiosError<HTTPError | ValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteReportsReportIdFilters>>,
    TError,
    { reportId: string; params: DeleteReportsReportIdFiltersParams },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof deleteReportsReportIdFilters>>,
  TError,
  { reportId: string; params: DeleteReportsReportIdFiltersParams },
  TContext
> => {
  const mutationOptions = getDeleteReportsReportIdFiltersMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Raises:
HTTPError: If the filter cannot be updated
HTTPError: If an unexpected error occurs.
HTTPError: If an HTTPException occurs.

Returns an updated filter.
Example:
{
"id": "1",
"reportId": "123123-1231231-123131-1231",
"userId": "1234",
"name": "filter",
"isDefaultFilter": "False",
"settings": [
{
"title": "visual title from Power BI",
"filters": []
}
]
}
 * @summary Updates the report filter
 */
export const putReportsReportIdFiltersReportFilterId = (
  reportId: string,
  reportFilterId: number,
  updateReportFilterInUpdate: UpdateReportFilterInUpdate,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<ReportFilter>> => {
  return axios.put(
    `${window._env_.POWER_BI_LIST_URL}/reports/${reportId}/filters/${reportFilterId}`,
    updateReportFilterInUpdate,
    options,
  );
};

export const getPutReportsReportIdFiltersReportFilterIdMutationOptions = <
  TError = AxiosError<HTTPError | ValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putReportsReportIdFiltersReportFilterId>>,
    TError,
    { reportId: string; reportFilterId: number; data: UpdateReportFilterInUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putReportsReportIdFiltersReportFilterId>>,
  TError,
  { reportId: string; reportFilterId: number; data: UpdateReportFilterInUpdate },
  TContext
> => {
  const { mutation: mutationOptions, axios: axiosOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putReportsReportIdFiltersReportFilterId>>,
    { reportId: string; reportFilterId: number; data: UpdateReportFilterInUpdate }
  > = (props) => {
    const { reportId, reportFilterId, data } = props ?? {};

    return putReportsReportIdFiltersReportFilterId(reportId, reportFilterId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutReportsReportIdFiltersReportFilterIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putReportsReportIdFiltersReportFilterId>>
>;
export type PutReportsReportIdFiltersReportFilterIdMutationBody = UpdateReportFilterInUpdate;
export type PutReportsReportIdFiltersReportFilterIdMutationError = AxiosError<HTTPError | ValidationError>;

/**
 * @summary Updates the report filter
 */
export const usePutReportsReportIdFiltersReportFilterId = <
  TError = AxiosError<HTTPError | ValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putReportsReportIdFiltersReportFilterId>>,
    TError,
    { reportId: string; reportFilterId: number; data: UpdateReportFilterInUpdate },
    TContext
  >;
  axios?: AxiosRequestConfig;
}): UseMutationResult<
  Awaited<ReturnType<typeof putReportsReportIdFiltersReportFilterId>>,
  TError,
  { reportId: string; reportFilterId: number; data: UpdateReportFilterInUpdate },
  TContext
> => {
  const mutationOptions = getPutReportsReportIdFiltersReportFilterIdMutationOptions(options);

  return useMutation(mutationOptions);
};
